export default "__VITE_PUBLIC_ASSET__62bce139__"